import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientKpisPage from "@/pages/client/ClientKpisPage";

export const Route = createFileRoute("/client/kpis")({
  head: () => pageHead("Client · Kpis", "AKIVA client · kpis portal.", "/client/kpis", true),
  component: ClientKpisPage,
});
